import {LocalStorage} from '@chekin/core';
import {checkUrl} from 'components/sessions/checkUrl';

const SESSION_KEY = 'user-session';
const SESSION_EXPIRATION_TIME = 1000 * 60 * 60 * 24; // 24 hours

type Session = {
  reservationId: string;
  redirectTo?: string;
  createdAt?: number;
};
export const createSession = ({reservationId, redirectTo}: Session) => {
  const session: Session = {
    reservationId,
    redirectTo: redirectTo || createRedirectToFromCurrentUrl(),
    createdAt: Date.now(),
  };

  LocalStorage.set(`${SESSION_KEY}-${reservationId}`, session);

  return session;
};

export const getSession = (reservationId: string) => {
  return LocalStorage.get<Session>(`${SESSION_KEY}-${reservationId}`);
};

export const createRedirectToFromCurrentUrl = () => {
  const url = new URL(window.location.href);
  const pathSegments = url.pathname.split('/').filter(Boolean);
  const basePath = pathSegments.length > 0 ? `/${pathSegments[0]}` : '';
  const redirectTo = `${url.origin}${basePath}`;
  return redirectTo;
};

export const removeExpiredSessions = () => {
  const sessionsKeys = LocalStorage.getKeys().filter(key => key.startsWith(SESSION_KEY));

  sessionsKeys.forEach(key => {
    const session = LocalStorage.get<Session>(key);
    if (
      session &&
      session.createdAt &&
      Date.now() - session.createdAt > SESSION_EXPIRATION_TIME
    ) {
      LocalStorage.remove(key);
    }
  });
};

export const closeSession = (reservationId?: string, extraPath?: string) => {
  const session = reservationId && getSession(reservationId);

  try {
    if (session) {
      LocalStorage.remove(`${SESSION_KEY}-${reservationId}`);

      if (session.redirectTo) {
        const path = extraPath
          ? `${session.redirectTo}/${extraPath}`
          : session.redirectTo;

        window.location.href = checkUrl(path);
      }
    }
  } catch (e) {
    console.error(e);
  }
};

export const hasSession = (reservationId?: string) => {
  return !!reservationId && !!getSession(reservationId);
};
